import { OnInit, Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { IDtoRequisition } from 'app/shared/models/opening/dto-requisition.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ValidatorService } from 'app/shared/services/validator.service';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { WorkingDayService } from 'app/views/appviews/quote/working-day.service';
import { OpeningService } from 'app/views/appviews/opening/opening.service';
import { DemandService } from 'app/views/appviews/demand.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { IDtoDemand } from 'app/shared/models/legal/demand/dto-demand.model';

@Component({
    selector: '[demand-process]',
    templateUrl: './demand-process.template.html',
    styleUrls: ['./demand-process.style.scss']
})
export class DemandProcessComponent implements OnInit, OnChanges {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;
    /**Formularios */
    private formDemandProcess: FormGroup;
    /**Notificaciones */
    private configToast: any;
    /**Inputs */
    @Input() private demand: IDtoDemand;
    @Output() getDemand = new EventEmitter<IDtoDemand>();
    /**Securty */
    private catalogLawyers: Observable<IDtoCatalog[]>;
    private catalogAuthorities: Observable<IDtoCatalog[]>;
    private catalogTypeConciliationMeetings: Observable<IDtoCatalog[]>;
    private catalogProceduralStages: IDtoCatalog[];
    @ViewChild('confirmSwal', { static: false }) private confirmSwal: SwalComponent;
    private liquidationId: number;
    step = 1;
    lockSaved: boolean;
    public constructor(private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private configurationService: ConfigurationService
        , private identityService: IdentityService
        , private demandService: DemandService
        , private route: ActivatedRoute) {
        this.initializeFormDemandProcess();
        this.configToast = configGeneral.getConfigToast();
    }
    ngOnInit(): void {
        this.demandService.currentStepChallenge$.subscribe((res) => {
            let diff = res - this.step;
            if (res > 0) {
               this.lockSaved = true;
            } else {
                this.lockSaved = false;
            }
        });
        if (this.configurationService.isReady) {
            this.getCatalog();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.getCatalog();
            });
        }
        this.route.params.subscribe((params) => {
            if (params['liquidationId']) {
                setTimeout(() => {
                    if (this.configurationService.isReady) {
                        this.liquidationId = params['liquidationId'];
                    } else {
                        this.configurationService.settingsLoaded$.subscribe(x => {
                            this.liquidationId = params['liquidationId'];
                        });
                    }
                }, 2);
            }
        });
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.demand.currentValue !== undefined && changes.demand.currentValue !== null) {
            if (this.demand.id > 0) {
                //TODO: REVISAR PORQUE CUANDO SE CARGA NO SE HANC ARGADO LOS CATALOGOS
                this.patchValueGeneralData();
            }
        }
    }
    private changeAuthority(dto: IDtoCatalog) {
        this.formDemandProcess.get('proceduralStageId').setValue(null);
        if (dto == undefined) {
            return;
        }
        this.demandService.getCatalogProceduralStages(dto.name).subscribe((x) => {
            this.catalogProceduralStages = x.filter(x => [1, 2].includes(x.id))
        });
        this.makeRequiredFields(dto.id);
    }

    private changeStage(dto: IDtoCatalog) {
        if (dto == undefined) {
            this.formDemandProcess.get('proceduralStageId').setValue(null);
            return;
        }
        this.demand.proceduralStageId = dto.id;
        this.getDemand.emit(this.demand)
    }

    private getCatalog() {
        this.catalogLawyers = this.demandService.getCatalogLawyers();
        this.catalogAuthorities = this.demandService.getCatalogAuthorities();
        this.catalogTypeConciliationMeetings = this.demandService.getCatalogTypeConciliationMeetings();
    }
    private initializeFormDemandProcess() {
        this.formDemandProcess = this.formBuilder.group({
            lawyerId: [null, [Validators.required]],
            authorityId: [null, [Validators.required]],
            typeConciliationMeetingId: [null, [Validators.required]],
            proceduralStageId: [null, [Validators.required]]
        });
    }
    private submitForm(form: FormGroup) {
        if (form.valid) {
            const value = form.value;
            this.demand.lawyerId = value.lawyerId;
            this.demand.authorityId = value.authorityId;
            this.demand.typeConciliationMeetingId = value.typeConciliationMeetingId;
            this.demand.proceduralStageId = value.proceduralStageId;
            this.demand.liquidationId = this.liquidationId;
            this.demand.step = this.step; 
            if (this.demand.id > 0) {
                //this.updateDemand();
            } else {
                this.addDemand();
            }
        } else {
            this.snotifyService.error('Llene todos los datos para poder continuar'
                , 'Error', this.configToast);
            this.configGeneral.touchedControls(form);
        }
    }
    private addDemand(): void {
        this.confirmSwal.title = 'Se guardarán los datos de la demanda. ¿Seguro que desea continuar?';
        this.confirmSwal.show().then((result) => {
            if (result.value) {
                this.spinner.show();
                this.demandService.addDemand(this.demand).subscribe(
                    (x) => {
                        if (x.isCorrect) {
                            this.configGeneral.newToast('Éxito', x.message, 'success');
                            this.demand = x.data as IDtoDemand;
                            this.getDemand.emit(this.demand)
                            this.demandService.currentStep(this.step);
                        } else {
                            this.configGeneral.newToast('Error', x.message, 'error');
                        }
                        this.spinner.hide();
                    },
                    (errMessage) => {
                        this.spinner.hide();
                        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                    });
            }
        });

    }
    private patchValueGeneralData(): void {
        this.catalogAuthorities.subscribe(c => {
            let authority = c.filter(x => x.id == this.demand.authorityId)[0];
            this.changeAuthority(authority);
        });

        this.formDemandProcess.patchValue(this.demand);
        this.formDemandProcess.disable();
    }
    private makeRequiredFields(value: number): void {
        if (value == 1) {
            this.formDemandProcess.get('typeConciliationMeetingId').setValidators([Validators.required]);
            this.formDemandProcess.get('proceduralStageId').setValidators([Validators.required]);
        } else {
            this.formDemandProcess.get('typeConciliationMeetingId').setValidators(null);
            this.formDemandProcess.get('proceduralStageId').setValidators(null);
        }
        this.formDemandProcess.get('typeConciliationMeetingId').updateValueAndValidity();
        this.formDemandProcess.get('proceduralStageId').updateValueAndValidity();
    }
    private addModuleLogDemand(): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'demands';
        dto.module = 'Demand';
        dto.action = 'add';
        dto.registryAffectedId = this.demand.id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
